import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from 'react-redux'
import L from 'leaflet';
import { setNewMapState } from '../../mapSlice';
import './Palette.css';

export default function Palette() {
  const [colors, setColors] = useState([]);
  const [values, setValues] = useState([]);
  const isMetric = useSelector((state) => state.map.isMetric);
  const dispatch = useDispatch();
  const paletteRef = useRef(null);

  useEffect(() => {
    const fetchPalette = async () => {
      const response = await fetch('https://web-dev1.customweather.com/jgdemo/web/client_sites/templates/route_demo_marine_sales/maps/CWVoyage2021/routes/cws/xmlProxy.php?client=bradburn&client_password=woll0BScre&product=palette&palette.name=rgbset_cwv_rain_hourly_M.cpt&format=json');
      const data = await response.json();
      const table = data.ColorPalette.table;
      const tempColorsArr = [];
      const tempValuesArr = [];
      for (const [key, value] of Object.entries(table)) {
        if (key !== 'background' && key !== 'foreground') {
          tempColorsArr.push(value.upper.hex.substring(2));
          tempValuesArr.push(Number.parseFloat(value.upper.level));
        }
      }
      if (colors.length < 1) {
        tempColorsArr.length = 6;
        setColors(tempColorsArr);
        setValues(tempValuesArr);
      }
    }

    fetchPalette();
  }, [colors, colors.length]);

  useEffect(() => {
    L.DomEvent.disableClickPropagation(paletteRef.current);
  });

  const config = {
    colors,
    volume: {
      // kmh: ["125", "100", "80", "60", "50", "40", "30", "20", "10", "5"],
      mm: ["1", "3", "6", "12", "24", "48"],
      inch: ["0.05", "0.1", "0.2", "0.5", "1.0", "2.0"],
    },
  };

  const handleSwitch = (e) => {
    dispatch(setNewMapState({ isMetric: !isMetric }))
  }

  const mmToInch = (mm) => {
    return Number.parseFloat(mm / 24.5).toFixed(1)
  }

  // const displaySpeeds = isMetric ? values.map((speed, i) => {
  //   // const displaySpeeds = isMetric ? config.speeds.kmh.map((speed, i) => {
  //   return (
  //     <div className={"palette-speeds"} id={`palette_speed${i}`} key={`palette_speed${i}`} >
  //       {speed}
  //     </div >
  //   );
  // }) : config.speeds.mph.map((speed, i) => {
  //   return (
  //     <div className={"palette-speeds"} id={`palette_speed${i}`} key={`palette_speed${i}`}>
  //       {speed}
  //     </div>
  //   );
  // })

  return (
    <div className={"leaflet-bottom leaflet-left "} style={{ width: '500px' }} >
      <div className={"leaflet-control leaflet-bar"} style={{ width: '100%' }}>
        <div className={"outer-palette-container"} ref={paletteRef} onClick={handleSwitch}>
          {/* <div className={'parent-palette-container'}> */}
          <div className={"palette-container"}>

            {config.colors.length > 1 ? config.colors.map((color, i) => {
              return (
                <div
                  key={`palette_color${i}`}
                  className={"palette-colors"}
                  id={`palette_color${i}`}
                  style={{
                    background: `#${color}`
                  }}
                ><span className={"palette-speeds"}>{!isMetric ? config.volume.inch[i] : config.volume.mm[i]}</span></div>
              );
            }) : null}
            <div className={'unit'}>
              <span className={isMetric ? 'highlight' : ''}>mm</span>
              <span>/</span>
              <span className={isMetric ? '' : 'highlight'}>in</span>
              {/* <div className={`unit ${isMetric ? 'highlight' : ''}`}>MM/</div><div className={`unit ${isMetric ? '' : 'highlight'}`}>IN</div></div> */}

            </div>

            {/* <div className={"speeds-container"}>
            {displaySpeeds}
          </div> */}

            <div className={'unit-horizontal'}>{isMetric ? 'KMH' : 'MPH'}</div>
            {/* </div> */}
          </div>
        </div>
      </div >
    </div>
  );
}
